export default __webpack_public_path__ + "static/allLogos-48b3cf2018e08511cecf12f263950b80.png";